import { IFeature } from 'mod/featureV2/interface';

export const techSpecs: IFeature = {
    moduleId: 'techSpecs',
    type: 'techSpecs',
    title: 'techSpecs',
    config: {
        showBtnText: 'See All Specs',
        hideBtnText: 'Hide All Specs',
    },
    list: [
        {
            src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
            width: 1200, //3840
            height: 581, //1860
        },
    ]
};

export const techSpecs2: IFeature = {
    ...techSpecs,
    moduleId: 'techSpecs2',
    config: {
        ...techSpecs.config,
        cardTheme: {
            background: {
                gradientTop: 'linear-gradient(155deg, #545454 0%, #282828 100%)',
                color: '#282828',
            },
            vars: {
                // '--feature-color-view-more': '#E4E1DC',
            }
        }
    },
};